import { FeatureFlags, useFeatureEnabled } from "~/v2/helpers/featureFlags";
import {
  type CustomMaintenanceWindow,
  useMaintenanceBannerController,
} from "./MaintenanceBanner.controller";
import { MaintenanceBannerPresentation } from "./MaintenanceBanner.pres";

export interface MaintenanceBannerControllerProps {
  customMaintenanceWindows?: CustomMaintenanceWindow[];
  className?: string;
}

const MaintenanceBannerContent = ({
  customMaintenanceWindows,
  className,
}: MaintenanceBannerControllerProps) => {
  const { bannerState } = useMaintenanceBannerController({
    customMaintenanceWindows,
  });

  if (!bannerState) {
    return null;
  }

  return (
    <MaintenanceBannerPresentation {...bannerState} className={className} />
  );
};

export const MaintenanceBannerConnector = ({
  customMaintenanceWindows,
  className,
}: MaintenanceBannerControllerProps) => {
  const isMaintenanceWindowDisabled = useFeatureEnabled(
    FeatureFlags.MAINTENANCE_WINDOW_DISABLED,
  );

  if (isMaintenanceWindowDisabled) {
    return null;
  }

  return (
    <MaintenanceBannerContent
      customMaintenanceWindows={customMaintenanceWindows}
      className={className}
    />
  );
};
